import React from 'react';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {
    formatDate,
    parseDate,
  } from 'react-day-picker/moment';
//import moment from 'moment';
import 'react-day-picker/lib/style.css';

import './SingleDatePickerWrapper.css';

class SingleDatePickerWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDay: undefined,
        };
    }

    onDayChange = (day) => {
        this.props.handleDayChange(day, this);
    } 

    render() {
        return (
            <div>
                <DayPickerInput
                    selectedDays={this.props.selectedDays || ''}
                    value={this.props.selectedDays ? `${formatDate(this.props.selectedDays)}` : ''}
                    onDayChange={this.onDayChange} 
                    format={this.props.format}
                    formatDate={formatDate}
                    parseDate={parseDate}
                    dayPickerProps={
                        this.props.disablePrevious ? ({
                            disabledDays:[
                                {
                                    before: new Date()
                                }
                            ]
                        }) : (
                            this.props.disableFuture && {
                                disabledDays:[
                                    {
                                        after: new Date()
                                    }
                                ]
                            }
                        )
                    }
                />
            </div>
        );
    }
  }

SingleDatePickerWrapper.propTypes = {
    handleDayChange: PropTypes.func,
    selectedDays: momentPropTypes.momentObj,
    format: PropTypes.string,
    disablePrevious: PropTypes.bool
}

export default SingleDatePickerWrapper;


// WEBPACK FOOTER //
// ./src/components/Common/SingleDatePickerWrapper/SingleDatePickerWrapper.js